var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/img/musicSheet/wow-no-data.png")}}),_c('p',{staticClass:"text"},[_vm._v("请移步到音乐窝APP"),_c('br'),_vm._v("进行扫一扫打开预览")])])])
}]

export { render, staticRenderFns }